import { render, staticRenderFns } from "./adminNavbar.vue?vue&type=template&id=4b72dea8&scoped=true"
import script from "./adminNavbar.vue?vue&type=script&lang=js"
export * from "./adminNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b72dea8",
  null
  
)

export default component.exports